import { createSelector } from 'reselect';
import { TEAMS } from '../constants/team.constants';
import { initialState } from '../reducers/team.reducer';
import {ADMIN_PAGE} from "../../containers/AdminPage/constants";
import {fromJS, List} from "immutable";

const selectState = state => state?.[TEAMS] || initialState;
const selectAdminState = state => state?.[ADMIN_PAGE] || fromJS({});

const selectTeamsData = createSelector(
	selectState,
	state => state.get('data')
);

const selectTeamsList = createSelector(
	[selectTeamsData, selectAdminState],
	(data, adminState) => {
		const teams = data.toList();
		if(!teams?.size) {
			return List(adminState.get('teams'));
		}
		return teams;
	}
);

export const selectTeams = createSelector(
	selectTeamsList,
	teams => teams.sortBy(t => t.name.toLowerCase())
);

export const selectTeamsFetched = createSelector(
	selectState,
	state => state.get('fetched')
);

export const selectSelectedTeam = createSelector(
	selectState,
	state => state.get('selectedTeam')
);